const formatCurrency = (value, currency, locale, decimalPlaces = 2, minDecimalPlaces = null) => {
  const minimumDecimalPlaces = minDecimalPlaces === null ? decimalPlaces : minDecimalPlaces;
  let language = locale;

  if (locale === 'gb') {
    language = 'en-gb';
  }

  let formatted = new Intl.NumberFormat(
    language, {
      minimumFractionDigits: minimumDecimalPlaces,
      maximumFractionDigits: decimalPlaces,
      style: 'currency',
      currency,
      useGrouping: true,
    },
  ).format(value);

  if (currency === 'AUD') {
    formatted = formatted.replace('AU$', 'A$');
  }

  if (currency === 'CAD') {
    formatted = formatted.replace('CA$', 'C$');
  }

  if (currency === 'MXN') {
    formatted = formatted.replace('MX$', 'MEX$');
  }

  if (currency === 'SGD') {
    formatted = formatted.replace('SGD', 'S$');
  }

  return formatted;
};

export default formatCurrency;
